import "./PagePickerElement-style";
import { ElementDataWatcher } from "lib/ElementDataWatcher";
import { LinkPageCriteria } from "./LinkPageModel";
import { LinkSession } from "./LinkSession";

class PagePickerElement extends HTMLElement {
    private criteriaWatcher: ElementDataWatcher<LinkPageCriteria>;

    connectedCallback() {
        if (this.hasAttribute("rendered"))
            return;
            
        this.criteriaWatcher = new ElementDataWatcher<LinkPageCriteria>(this, "link-page-criteria");
        const currentPage = this.criteriaWatcher.data?.page;

        if (!currentPage)
            return;
            
        const pageCount = parseInt(this.getAttribute("page-count"));

        if (pageCount <= 1) {
            this.remove();
            return;
        }
            
        const allPages = [...Array(pageCount+1).keys()].slice(1);  

        let slack = 1;
        let range: number[];
        const pageIndex = currentPage-1;

        do {
            slack++;
            range = allPages.slice(Math.max(0, pageIndex-slack), Math.min(pageIndex+slack+1, allPages.length)); // +1 = skip current

        } while(range.length < 5 && slack < allPages.length);

        let firstPage;
        if (range[0] > allPages[0])
            firstPage = 1;

        let lastPage
        if (range[range.length-1] < allPages[allPages.length-1])
            lastPage = allPages[allPages.length-1];

        this.innerHTML = this.view(range, this.criteriaWatcher.data, currentPage, firstPage, lastPage);

        this.addEventListener("click", this.clickHandler);
    }

    private clickHandler = (event: MouseEvent) => {
        if (!(event.target instanceof Element))
            return;

        const pickPage = (<Element>event.target).closest("[pick-page]");
        if (!pickPage)
            return;

        this.dispatchEvent(new CustomEvent("changed", { detail: parseInt(pickPage.getAttribute("pick-page")) }));
        
    }

    private routeAttribute = () => document.body.classList.contains("authenticated") ? "route" : "";
    

    private view = (pages: number[], criteria: LinkPageCriteria, currentPage: number, firstPage?: number, lastPage?: number) => `
        ${currentPage > pages[0] ? `
            <a href="${this.buildUrl(criteria, currentPage-1)}" ${this.routeAttribute()}>${require("!!raw-loader!image/arrow-left-20-v1.svg")}</a>
        ` : ""}
        
        ${firstPage ? `
            <a href="${this.buildUrl(criteria, firstPage)}" ${this.routeAttribute()}>${firstPage}</a>
            ${firstPage < pages[0]-1 ? "..." : ""}
        ` : "" }
        
        
        ${pages.map(page => `<a href="${this.buildUrl(criteria, page)}" ${this.routeAttribute()}${currentPage === page ? " current" : ""}>${page}</a>`).join("")}
        
        
        ${lastPage ? `
            ${lastPage > pages[pages.length-1]+1 ? "..." : ""}
            <a href="${this.buildUrl(criteria, lastPage)}" ${this.routeAttribute()}>${lastPage}</a>
            
        ` : "" }
        
        ${currentPage < pages[pages.length-1] ? `
            <a href="${this.buildUrl(criteria, currentPage+1)}" ${this.routeAttribute()}>${require("!!raw-loader!image/arrow-right-20-v1.svg")}</a>
        ` : ""}

       
        
    `;

    private buildUrl(criteria: LinkPageCriteria, page: number) : URL {
        criteria.page = page;
        return LinkSession.buildUrl(criteria);
    }
}

customElements.define("page-picker", PagePickerElement);